import PropTypes from 'prop-types';
import React from 'react';
import Helmet from 'react-helmet';
import classnames from 'classnames/bind';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import merge from 'lodash/merge';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import redirectAction from 'yoda-app-shell/lib/action/RedirectAction';
import Cookies from 'yoda-core-components/lib/helpers/Cookies/Cookies';
import LocalStorage from 'yoda-core-components/lib/helpers/LocalStorage/LocalStorage';
import SiteComponent from 'yoda-site-components/lib/components/SiteComponent/SiteComponent';
import * as LocationServiceAction from 'yoda-site-components/lib/actions/LocationServiceAction';
import ShipAndPayPreShellLoader from 'yoda-checkout-components/lib/components/PreShellLoaders/ShipAndPayPreShellLoader/ShipAndPayPreShellLoader';
import CheckoutHeader from 'yoda-checkout-components/lib/components/CheckoutHeader/CheckoutHeader';
import Footer from 'yoda-checkout-components/lib/components/Footer/Footer';
import LiveChat from 'yoda-checkout-components/lib/components/LiveChat/LiveChat';
import DelaySpinner from 'yoda-checkout-components/lib/components/DelaySpinner/DelaySpinner';
import OrderSummaryPreShellLoader from 'yoda-checkout-components/lib/components/PreShellLoaders/OrderSummaryPreShellLoader/OrderSummaryPreShellLoader';
import withBoundaryError from 'yoda-checkout-components/lib/components/ErrorBoundary/ErrorBoundaryHOC';
import {
    ANALYTICS_ACTIONS_PRODUCT_CO_OOS,
    PAGE_TITLES_CHECKOUT,
    CREATE_ACC_SUCCESS_MSG,
} from 'yoda-checkout-components/lib/common/Constants';
import * as CheckoutAnalyticsAction from 'yoda-checkout-components/lib/actions/CheckoutAnalyticsAction';
import * as outOfStockActions from 'yoda-checkout-components/lib/actions/OutOfStockActions';
import * as showGlobalLoaderAction from 'yoda-checkout-components/lib/actions/ShowGlobalLoaderAction';
import * as orderSubmittableAction from 'yoda-checkout-components/lib/actions/OrderSubmittableAction';
import * as applePayAction from 'yoda-checkout-components/lib/actions/PayWithAppleAction';
import * as clearCouponAction from 'yoda-checkout-components/lib/actions/COAdjustmentAction';
import makeQuery from 'yoda-core-components/lib/navigation/query/makeQuery';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import StickyBetween from 'yoda-site-components/lib/components/StickyBetween/StickyBetween';
import B2BVoucherHeader from 'yoda-site-components/lib/components/B2BVoucher/B2bVoucherHeader';
import {
    isAgentLogged,
    isSentToAgencyFromCart,
} from 'yoda-core-components/lib/helpers/Utils/Utils';
import {
    OOSModal,
    SessionTimeoutModal,
    SerialCodeInputModal,
    CouponsPanel,
    ShowRewardsPanel,
    GenericOopsMessage,
    NewShippingPage,
    NewPaymentPage,
    NewSameDayPickupPage,
} from '../../../LazyModules/LazyModules';
import * as checkoutPageActions from '../../../actions/CheckoutPageActions';
import * as getCartDetailsAction from '../../../actions/GetCartDetailsAction';
import * as NewPaymentActions from '../../../actions/NewPaymentAction';
import * as NewShippingActions from '../../../actions/NewShippingAction';
import CheckoutAccordionHeader from '../../../components/NewCheckoutHeader/NewCheckoutHeader';
// eslint-disable-next-line import/no-named-as-default
import OrderSummary from '../../../components/OrderSummary/OrderSummary';
import * as styles from './NewCheckoutPage.css';
import ShipToStoreContainer from '../NewShippingPage/ShipToStoreContainer/ShipToStoreContainerLazy';

const cx = classnames.bind(styles);
export class NewCheckoutPage extends SiteComponent {
    constructor() {
        super();
        this.state = {
            sendingToAgency: false,
            isAgent: false,
        };
        this.isOOSDACalled = false;
        this.isPreLoadComponentNotLoaded = true;
    }

    hydrateOnMount() {
        // Added this object initialization to allow ensighten team to fix the issue.
        if (!__SERVER__) {
            window.jcpDLjcp = {};
            this.props.actions.setApplePayAccountEligible();
        }
        let isRenderUpdated = !get(this.props, 'orderDetails.renderFrom');
        if (!isRenderUpdated) {
            isRenderUpdated = this.props.orderDetails.renderFrom !== this.props.renderFrom;
        }
        if (isEmpty(this.props.checkoutInfo) || isRenderUpdated) {
            const { from = '' } = makeQuery(this.props.location.search);
            const isLoadedFromReview = from === 'review';
            let pageName = 'delivery';
            if (this.props.renderFrom === 'payment') {
                pageName = this.props.renderFrom;
            }
            const options = {
                includeServiceLevels: true,
                pageName,
                renderFrom: this.props.renderFrom,
                isLoadedFromReview,
            };
            this.props.actions.getCartDetails(options);
        }
        this.props.actions.loadUserStoreLocationInfo();
    }

    /* istanbul ignore next */
    componentDidMount() {
        const { actions, isNative } = this.props;
        actions.setOrderSubmittable(false);
        const isAccCreated = LocalStorage.getData('ACC_CREATED_IN_CHECKOUT', true);
        if (!__SERVER__ && isAccCreated === 'true') {
            actions.setCreateAccountMessage(CREATE_ACC_SUCCESS_MSG);
            setTimeout(
                /* istanbul ignore next */
                () => {
                    actions.setCreateAccountMessage('');
                },
                10000
            );
            LocalStorage.removeData('ACC_CREATED_IN_CHECKOUT', true);
        }
        this.loadExternalComponentsAfterStateReady();
        this.setRewardsPilotIndicator();
        if (isNative) {
            this.props.actions.initNewShippingSectionUI();
        }
        /* B2B Voucher Portal code */
        /* istanbul ignore next */
        if (isSentToAgencyFromCart(this.props.context)) {
            this.setState({ sendingToAgency: true });
        }

        /* istanbul ignore next */
        if (isAgentLogged(this.props.context)) {
            this.setState({ isAgent: true });
        }
    }

    componentDidUpdate() {
        this.loadExternalComponentsAfterStateReady();
        if (this.props.isSessionTimedOut && this.props?.couponDisplayModal?.displayModal) {
            this.props.actions.clearCouponDisplayModal();
        }
    }

    /* istanbul ignore next */
    loadExternalComponentsAfterStateReady = () => {
        if (!__SERVER__ && this.isPreLoadComponentNotLoaded && !isEmpty(this.props.checkoutInfo)) {
            /* istanbul ignore next */
            if (document.readyState === 'complete') {
                this.loadPreLoadComponents();
            } else {
                window.addEventListener(
                    'load',
                    /* istanbul ignore next */
                    () => {
                        this.loadPreLoadComponents();
                    }
                );
            }
        }
    };

    /**
     * It will preload the checkout page lazy components
     */
    loadPreLoadComponents = () => {
        const fromReview = this.props.checkoutInfo.isLoadedFromReview;
        if (fromReview) {
            return;
        }
        const showSameDayPickup = get(this.props.checkoutInfo, 'SDPU.isExists');
        const showShippingSection = get(this.props.checkoutInfo, 'shipping.isExists');
        const showPaymentSection = this.state.sendingToAgency
            ? false
            : get(this.props.checkoutInfo, 'payment.isExists');
        showSameDayPickup && NewSameDayPickupPage.preload();
        showShippingSection && NewShippingPage.preload();
        showShippingSection && ShipToStoreContainer.preload();
        showPaymentSection && NewPaymentPage.preload();
        CouponsPanel.preload();
        this.isPreLoadComponentNotLoaded = false;
    };

    renderOOSModal = () => {
        const { oosDetails } = this.props;
        const oosItemProducts = get(oosDetails, 'discontinuedOOSDetails.oosItemProducts', []);
        const discontinuedItemProducts = get(
            oosDetails,
            'discontinuedOOSDetails.discontinuedItemProducts',
            []
        );
        if (!oosDetails.isShowModal) {
            return null;
        }
        const products = [...oosItemProducts, ...discontinuedItemProducts];
        /* istanbul ignore else */
        if (!this.isOOSDACalled && !isEmpty(products) && oosDetails.isShowModal) {
            this.props.actions.clickEventAnalyticsAction(ANALYTICS_ACTIONS_PRODUCT_CO_OOS);
            this.isOOSDACalled = true;
        }
        const isShowCheckout =
            !oosDetails.isAllItemsOos &&
            !oosDetails.isAllItemsDiscontinued &&
            !oosDetails.isAllItemsDiscontinuedAndOOS;
        return (
            <OOSModal
                // defaultCloseBtn={true}
                products={products}
                isShowModal={oosDetails.isShowModal}
                isShowCheckout={isShowCheckout}
                actions={this.props.actions}
            />
        );
    };

    renderSlidePanel = () => {
        return (
            <section>
                <SerialCodeInputModal pageInfo="checkout" />
                <ShowRewardsPanel pageInfo="checkout" checkoutFlow />
                <CouponsPanel pageInfo="checkout" panelTitle="Coupons" />
            </section>
        );
    };

    setRewardsPilotIndicator = () => {
        const rewardsPilot = Cookies.load('eligibleForRewardsPilot') || false;
        if (rewardsPilot) {
            this.setState({ rewardsPilotIndicator: true });
        }
    };

    /* istanbul ignore next */
    render() {
        const {
            showGlobalLoader,
            orderInfo,
            deviceType,
            isSessionTimedOut,
            preferences,
            checkoutInfo,
            renderFrom,
            showBlurBG,
        } = this.props;
        const renderSdpu = renderFrom === 'bopis';
        const renderShipping = renderFrom === 'shipping';
        /* istanbul ignore next */
        const renderPayment =
            this.props.featureFlags.enableB2BVoucher && this.state.sendingToAgency
                ? false
                : renderFrom === 'payment';
        const activeLoaderClass = showGlobalLoader ? 'disableUserActions' : '';
        const showSameDayPickup = get(checkoutInfo, 'SDPU.isExists');
        const showShippingSection = get(checkoutInfo, 'shipping.isExists');
        /* istanbul ignore next */
        const showPaymentSection =
            this.props.featureFlags.enableB2BVoucher && this.state.sendingToAgency
                ? false
                : get(checkoutInfo, 'payment.isExists');
        const showReviewSection = get(checkoutInfo, 'review.isExists');
        const fromReview = checkoutInfo.isLoadedFromReview;
        const isOrderDetailsLoading = !(orderInfo && orderInfo.id);
        const blurClass = showBlurBG ? dt(['blur-sm']) : '';
        const pointerClass = !deviceType.isDesktop ? dt(['cursor-pointer']) : '';
        const { rewardsPilotIndicator } = this.state;
        const orderSummaryStylesLg = isOrderDetailsLoading
            ? `${dt(['w-full'])}`
            : `${dt([
                  'shadow-none',
                  'border',
                  'border-solid',
                  'border-gray-15',
                  'bg-white',
                  'rounded-lg',
                  '!m-0',
                  '!p-4',
              ])}`;
        const orderSummaryStylesSm = isOrderDetailsLoading
            ? `${dt(['w-full'])}`
            : `${dt([
                  'shadow-none',
                  'border',
                  'border-solid',
                  'border-gray-15',
                  'bg-white',
                  'rounded-lg',
                  '!my-0',
                  'mx-auto',
                  'smMd:!p-4',
              ])}`;
        return (
            <section
                className={`${cx(
                    'checkoutMainWrapper',
                    'tailwindGrid',
                    blurClass,
                    pointerClass,
                    activeLoaderClass
                )} ${dt(['relative', 'overflow-hidden', 'bg-white', 'font-open-sans-regular'])}`}
                id={rewardsPilotIndicator ? 'eligible-for-rewards-pilot' : ''}
                data-automation-id="at-checkout-main-wrapper"
            >
                <Helmet title={PAGE_TITLES_CHECKOUT} />
                {/* istanbul ignore next */}
                {this.state.isAgent && <B2BVoucherHeader />}

                <CheckoutHeader
                    items={this.props.orderInfo.itemsCount}
                    deviceType={deviceType}
                    feedbackToken={preferences.feedbackToken}
                />
                <GenericOopsMessage />
                <section
                    className={`${cx('checkoutBlock')} ${dt([
                        'bg-white',
                        'my-6',
                        'mx-auto',
                        'px-6',
                        'max-w-[1440px]',
                        'tailwindGrid',
                        'h-full',
                        'text-black',
                    ])}`}
                    data-automation-id="at-checkout-main-block"
                >
                    <article>
                        {this.renderOOSModal()}
                        {isSessionTimedOut && (
                            <SessionTimeoutModal isShowModal={isSessionTimedOut} />
                        )}
                        {activeLoaderClass && <DelaySpinner />}
                        <section
                            className={`${cx('checkoutContent')} ${dt([
                                'relative',
                                'smMd:py-0',
                                'flex',
                                'justify-between',
                                'smMd:flex-wrap',
                            ])}`}
                        >
                            <section
                                className={`${cx(
                                    'sm12',
                                    'md12',
                                    'lg7',
                                    'xl7',
                                    'checkoutAccordianOuterWrapper'
                                )} ${dt(['sm:!p-0'])}`}
                            >
                                {isOrderDetailsLoading ? (
                                    <ShipAndPayPreShellLoader />
                                ) : (
                                    <section
                                        className={`${cx(
                                            'rowblock',
                                            'checkoutAccordianWrapper'
                                        )} ${dt(['sm:p-0', 'bg-white', 'mx-0'])}`}
                                        data-automation-id="checkout-page-accordion"
                                    >
                                        {showSameDayPickup && (
                                            <CheckoutAccordionHeader
                                                active={renderSdpu}
                                                showEdit={
                                                    !fromReview &&
                                                    !renderSdpu &&
                                                    (renderShipping || renderPayment)
                                                }
                                                index={checkoutInfo.SDPU.index}
                                                title="Same Day Pickup"
                                                editAction={
                                                    this.props.actions
                                                        .initNewCheckoutSectionsClientSideActions
                                                }
                                            />
                                        )}
                                        {renderSdpu && (
                                            <div
                                                className={`${cx('checkoutSection')} ${dt([
                                                    'lg:bg-light-white',
                                                    'lg:p-2',
                                                    'lg:mb-6',
                                                    'lg:rounded-tl-none',
                                                    'lg:rounded-tr-none',
                                                    'lg:rounded-bl-lg',
                                                    'lg:rounded-br-lg',
                                                ])}`}
                                            >
                                                <NewSameDayPickupPage />
                                            </div>
                                        )}
                                        {showShippingSection && (
                                            <CheckoutAccordionHeader
                                                active={renderShipping}
                                                showEdit={
                                                    !fromReview && !renderShipping && renderPayment
                                                }
                                                index={checkoutInfo.shipping.index}
                                                title="Shipping"
                                                editAction={
                                                    this.props.actions
                                                        .initNewCheckoutSectionsClientSideActions
                                                }
                                            />
                                        )}
                                        {renderShipping && (
                                            <div
                                                className={`${cx('checkoutSection')} ${dt([
                                                    'lg:bg-light-white',
                                                    'lg:p-2',
                                                    'lg:mb-6',
                                                    'lg:rounded-tl-none',
                                                    'lg:rounded-tr-none',
                                                    'lg:rounded-bl-lg',
                                                    'lg:rounded-br-lg',
                                                ])}`}
                                            >
                                                <NewShippingPage />
                                            </div>
                                        )}
                                        {/* istanbul ignore next */}
                                        {/*  B2B Voucher Portal code */}
                                        {/* dont dispay payment for B2B Client */}
                                        {!this.state.sendingToAgency && showPaymentSection && (
                                            <CheckoutAccordionHeader
                                                active={renderPayment}
                                                index={checkoutInfo.payment.index}
                                                title="Payment"
                                            />
                                        )}
                                        {/* istanbul ignore next */}
                                        {!this.state.sendingToAgency && renderPayment && (
                                            <div
                                                className={`${cx('checkoutSection')} ${dt([
                                                    'lg:bg-light-white',
                                                    'lg:p-2',
                                                    'lg:mb-6',
                                                    'lg:rounded-tl-none',
                                                    'lg:rounded-tr-none',
                                                    'lg:rounded-bl-lg',
                                                    'lg:rounded-br-lg',
                                                ])}`}
                                            >
                                                <NewPaymentPage />
                                            </div>
                                        )}
                                        {showReviewSection && (
                                            <CheckoutAccordionHeader
                                                index={checkoutInfo.review.index}
                                                title="Review"
                                            />
                                        )}
                                    </section>
                                )}
                            </section>
                            <section
                                className={`${cx(
                                    'hiddenSm',
                                    'hiddenTwMd',
                                    'lg4',
                                    'xl4',
                                    'orderSummaryWrapper'
                                )} ${dt([
                                    'sm:!p-0',
                                    'mdOnly:h-full',
                                    'mdOnly:absolute',
                                    'mdOnly:bg-white',
                                ])}`}
                                data-automation-id="at-ordersummarywrapper-large"
                            >
                                <StickyBetween>
                                    <div
                                        className={`${cx(
                                            'rowBlock',
                                            'orderSummary'
                                        )} ${orderSummaryStylesLg}`}
                                    >
                                        <div
                                            className={`${cx(
                                                'row',
                                                'orderSummaryInnerWrapper'
                                            )} ${dt(['!p-0', '!m-0'])}`}
                                        >
                                            {isOrderDetailsLoading ? (
                                                <OrderSummaryPreShellLoader />
                                            ) : (
                                                <OrderSummary isShowCouponPricing />
                                            )}
                                        </div>
                                    </div>
                                </StickyBetween>
                            </section>
                            <section
                                className={`${cx(
                                    'sm12',
                                    'visibleSmMd',
                                    'md12',
                                    'orderSummaryWrapper'
                                )} ${dt(['mdOnly:bg-white', '!p-0'])}`}
                                data-automation-id="at-ordersummarywrapper-small"
                            >
                                <div
                                    className={`${cx(
                                        'rowBlock',
                                        'orderSummary'
                                    )} ${orderSummaryStylesSm}`}
                                >
                                    <div
                                        className={`${cx('row', 'orderSummaryInnerWrapper')} ${dt([
                                            'sm:!m-0',
                                            '!p-0',
                                        ])}`}
                                    >
                                        {isOrderDetailsLoading ? (
                                            <OrderSummaryPreShellLoader />
                                        ) : (
                                            <OrderSummary isShowCouponPricing />
                                        )}
                                    </div>
                                </div>
                            </section>
                        </section>
                    </article>
                    <LiveChat />
                </section>
                <Footer
                    isDesktop={this.props.deviceType.isDesktop}
                    phoneNumber={preferences.jcpHelpPhoneNumber}
                    context={this.props.context}
                />
                {!__SERVER__ && this.renderSlidePanel()}
            </section>
        );
    }
}
NewCheckoutPage.propTypes = {
    actions: PropTypes.objectOf(PropTypes.func).isRequired,
    orderInfo: PropTypes.objectOf(PropTypes.object).isRequired,
    checkoutInfo: PropTypes.objectOf(PropTypes.object),
    orderDetails: PropTypes.arrayOf(PropTypes.object).isRequired,
    showGlobalLoader: PropTypes.bool.isRequired,
    oosDetails: PropTypes.oneOfType(PropTypes.object).isRequired,
    orderItems: PropTypes.oneOfType(PropTypes.object).isRequired,
    deviceType: PropTypes.objectOf(PropTypes.object).isRequired,
    isSessionTimedOut: PropTypes.bool,
    featureFlags: PropTypes.objectOf(PropTypes.object),
    preferences: PropTypes.objectOf(PropTypes.object),
    context: PropTypes.objectOf(PropTypes.object).isRequired,
    renderFrom: PropTypes.string,
    mountOnServer: PropTypes.bool,
    location: PropTypes.objectOf(PropTypes.any).isRequired,
    showBlurBG: PropTypes.bool,
    isNative: PropTypes.bool,
    couponDisplayModal: PropTypes.objectOf(PropTypes.object),
};

NewCheckoutPage.defaultProps = {
    isSessionTimedOut: false,
    orderGiftRegistries: {},
    addressList: {},
    featureFlags: {},
    preferences: {},
    checkoutInfo: {},
    renderFrom: 'shipping',
    mountOnServer: true,
    showBlurBG: false,
    isNative: false,
    couponDisplayModal: {},
};
const mapStateToProps = (state) => ({
    orderDetails: state.orderDetails,
    checkoutInfo: state.checkoutInfo,
    orderInfo: state.orderInfo,
    showGlobalLoader: state.showGlobalLoader,
    oosDetails: state.oosDetails,
    orderItems: state.orderItems,
    deviceType: state.context.deviceType,
    isSessionTimedOut: state.session.isSessionTimedOut,
    featureFlags: state.context.featureFlags,
    preferences: state.context.preferences,
    isNative: state.context.isNative,
    couponDisplayModal: state.couponDisplayModal,
    context: state.context,
    mountOnServer: get(state, 'context.featureFlags.enableCheckoutServerSideRendering', true),
    showBlurBG: get(state, 'applePayOrderInfo.showApplePaySheet', false),
});
const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(
        merge(
            {},
            getCartDetailsAction,
            showGlobalLoaderAction,
            outOfStockActions,
            checkoutPageActions,
            CheckoutAnalyticsAction,
            orderSubmittableAction,
            applePayAction,
            clearCouponAction,
            redirectAction,
            LocationServiceAction,
            NewPaymentActions,
            NewShippingActions
        ),
        dispatch
    ),
});
export default withBoundaryError(
    connect(mapStateToProps, mapDispatchToProps)(NewCheckoutPage),
    'NEW_CHECKOUT'
);
